/*
  cookie-consent.js — Les Amis.
  Creado 2026-09-18 (auditoria, bloqueante 3 + prioridad alta 4/5).
  Guarda la eleccion en localStorage, sincroniza con la Customer
  Privacy API nativa de Shopify cuando esta disponible, y avisa al
  resto de la pagina (chat de n8n, mapa de Google) mediante el evento
  "lesamis:consent-updated" para que no se carguen scripts ni iframes
  de terceros antes de tener consentimiento.

  2026-09-21: en movil, el popup "5% de descuento" (app Shopify Forms,
  <shopify-forms-embed>) y este banner podian aparecer a la vez -- el
  popup usa z-index:2147483647 (el maximo posible) dentro de su propio
  shadow root, asi que se comia los clics del banner aunque el banner
  se viera "debajo". formsPopupVisible() + el retraso en initBanner()
  hacen que el banner espere a que ese popup no este visible (o a un
  tope de ~8s por si el popup nunca aparece) antes de mostrarse.
*/
(function () {
  var STORAGE_KEY = 'lesamis_consent';
  var listeners = [];

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (typeof parsed.analytics !== 'boolean' || typeof parsed.marketing !== 'boolean') return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function writeStored(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (e) {
      /* localStorage no disponible (modo privado, etc.): la eleccion no persiste entre visitas */
    }
  }

  function syncShopifyPrivacy(consent) {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: consent.analytics,
          marketing: consent.marketing,
          preferences: true,
          sale_of_data: consent.marketing
        }, function () {});
      }
    } catch (e) {
      /* API de privacidad de Shopify no disponible todavia: no rompe el resto del flujo */
    }
  }

  function dispatchUpdate(consent) {
    listeners.forEach(function (cb) {
      try { cb(consent); } catch (e) {}
    });
    try {
      window.dispatchEvent(new CustomEvent('lesamis:consent-updated', { detail: consent }));
    } catch (e) {}
  }

  function setConsent(consent) {
    var value = {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      ts: Date.now()
    };
    writeStored(value);
    syncShopifyPrivacy(value);
    dispatchUpdate(value);
    return value;
  }

  window.lesamisConsent = {
    get: readStored,
    granted: function (category) {
      var c = readStored();
      return !!(c && c[category]);
    },
    set: setConsent,
    onUpdate: function (cb) {
      if (typeof cb === 'function') listeners.push(cb);
      var current = readStored();
      if (current) {
        try { cb(current); } catch (e) {}
      }
    }
  };

  function formsPopupVisible() {
    try {
      var host = document.querySelector('shopify-forms-embed');
      if (!host || !host.shadowRoot) return false;
      var nodes = host.shadowRoot.querySelectorAll('[data-form-root="true"], [data-current-step]');
      for (var i = 0; i < nodes.length; i++) {
        var r = nodes[i].getBoundingClientRect();
        if (r.width > 40 && r.height > 40) return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  function initBanner() {
    var banner = document.getElementById('lesamis-cookie-banner');
    if (!banner) return;

    var existing = readStored();
    if (existing) {
      syncShopifyPrivacy(existing);
      return;
    }

    var detail = document.getElementById('lesamis-cookie-detail');
    var analyticsBox = document.getElementById('lesamis-cookie-analytics');
    var marketingBox = document.getElementById('lesamis-cookie-marketing');
    var acceptBtn = banner.querySelector('[data-cookie-accept]');
    var rejectBtn = banner.querySelector('[data-cookie-reject]');
    var configureBtn = banner.querySelector('[data-cookie-configure]');
    var saveBtn = banner.querySelector('[data-cookie-save]');

    function close() {
      banner.hidden = true;
    }

    function reveal() {
      /* Espera minima antes de decidir: al primer tick, shopify-forms-embed
         puede no haber montado su contenido todavia (falso negativo), asi
         que no basta con comprobar una sola vez nada mas cargar. */
      var minDelayDone = false;
      var attemptsLeft = 20; /* ~8s de reintentos tras la espera minima */
      setTimeout(function () { minDelayDone = true; }, 1200);

      (function tick() {
        if (minDelayDone && (attemptsLeft <= 0 || !formsPopupVisible())) {
          banner.hidden = false;
          return;
        }
        attemptsLeft--;
        setTimeout(tick, 400);
      })();
    }
    reveal();

    acceptBtn.addEventListener('click', function () {
      setConsent({ analytics: true, marketing: true });
      close();
    });
    rejectBtn.addEventListener('click', function () {
      setConsent({ analytics: false, marketing: false });
      close();
    });
    configureBtn.addEventListener('click', function () {
      var isHidden = detail.hidden;
      detail.hidden = !isHidden;
      configureBtn.hidden = isHidden;
      saveBtn.hidden = !isHidden;
    });
    saveBtn.addEventListener('click', function () {
      setConsent({
        analytics: !!(analyticsBox && analyticsBox.checked),
        marketing: !!(marketingBox && marketingBox.checked)
      });
      close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBanner);
  } else {
    initBanner();
  }
})();
